export default "/images/frown.svg?65c267ab593555796e1f30575f12e6e2";